import React from 'react';
import {PdfPageBreak} from '@drivesally/sally-ui';
import {v4} from 'uuid';

export default () => <PdfPageBreak key={v4()} />;
